export default "__VITE_ASSET__DwpLoJ7u__"